import { Injectable } from '@angular/core';
import { AppCollection } from '../../app.config';
import { BaseCollectionService } from '../../core/jsonApi/BaseCollectionService';
import { ModuleJsonModel } from '../module.json.model';

@Injectable({
  providedIn: 'root'
})
export class ModuleService extends BaseCollectionService<ModuleJsonModel, AppCollection> {
  protected ctor = ModuleJsonModel;
}
